import * as React from "react"
import { BadgeButton } from "components-design-system"
import PropTypes from "prop-types"

import regionColorMap from "components-design-system/badges/regionColorMap"

const registryRegionMap = {
  global: "global",
  ctg: "americas",
  eupas: "europe",
  ctis: "europe",
  jrct: "asia",
}

const getColor = (registry) => {
  if (registry) {
    return regionColorMap[registryRegionMap[registry?.toLowerCase()]]
  }
  return "gray"
}

const RegistryFilterButton = ({ registry, defaultFilterState, filterValue, onChangeFilter, validateStatus }) => {
  return (
    <BadgeButton
      label={registry?.toUpperCase()}
      defaultFilterValue={defaultFilterState}
      filterValue={filterValue}
      onChangeFilter={onChangeFilter}
      colorName={getColor(registry)}
      validateStatus={validateStatus}
      className="registry-filter-button"
      dataDogActionName={registry?.toUpperCase()}
    />
  )
}

RegistryFilterButton.propTypes = {
  registry: PropTypes.string,
  defaultFilterState: PropTypes.bool,
  filterValue: PropTypes.bool,
  onChangeFilter: PropTypes.func,
  validateStatus: PropTypes.oneOf(["default", "warning", "success"]),
}

export default RegistryFilterButton
